import { SpeciesIcon } from '@/frontend/features/patient/species-icon'
import { cn } from '@/frontend/lib/utils'

/** Round patient photo, falling back to the species icon when there is none. */
export function PatientAvatar({
  src,
  species,
  name,
  className,
}: {
  src: string | null
  species: string
  name: string
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex size-15 shrink-0 items-center justify-center overflow-hidden rounded-full bg-muted',
        className
      )}
    >
      {src ? (
        <img src={src} alt={name} className="size-full object-cover" />
      ) : (
        <SpeciesIcon species={species} className="size-7 text-muted-foreground" />
      )}
    </div>
  )
}
